
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/industry/education/whatsapp",
      function () {
        return require("private-next-pages/industry/education/whatsapp.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/industry/education/whatsapp"])
      });
    }
  